export default __webpack_public_path__ + "static/media/LM-logo.e20d6c2e.png";